import { coberturaDe } from "../../utils/coberturaPaciente";
import "../../styles/CitasAgenda.css";

/* ============================================================================
   CITAS-COBERTURA · a qué pertenece el paciente, al elegirlo

   Al crear o editar una cita, elegir al paciente no decía nada de su
   cobertura: ni si era particular, de seguro o de empresa, ni qué plan tiene
   asignado. Y eso decide si se cobra en el momento y con qué tarifario.

   NO PIDE NADA AL SERVIDOR: `GET /listar_paciente` ya incluye `tipo_seguros`,
   `seguros` y `plan` -- el objeto del paciente que el selector entrega los
   trae. Esto sólo los pinta.

   Si el paciente no tiene cobertura cargada, no se pinta nada: un hueco es
   más honesto que un "Particular" supuesto.
   ========================================================================== */

export default function CoberturaPaciente({ paciente }) {
    const cobertura = coberturaDe(paciente);
    if (!cobertura) return null;

    return (
        <div className="ccob" data-testid="cita-cobertura">
            <span className={`ccob__chip ccob__chip--${cobertura.tono}`}>{cobertura.etiqueta}</span>

            {/* El tipo sólo se repite cuando aporta: "Seguros" al lado de
                "Latinasalud" informa; al lado de "Particular", no. */}
            {cobertura.detalle !== cobertura.etiqueta && (
                <span className="ccob__tipo">{cobertura.detalle.split(" · ")[0]}</span>
            )}

            {cobertura.plan ? (
                <span className="ccob__plan">
                    Plan: <b>{cobertura.plan}</b>
                </span>
            ) : (
                /* Un paciente de seguro SIN plan es un caso que caja necesita
                   ver antes de facturar, no un hueco cualquiera. */
                cobertura.tono === "info" && <span className="ccob__sinplan">Sin plan asignado</span>
            )}
        </div>
    );
}
